import ArrowRight from "@/src/sb/components/icon/ArrowRight"
import Lite from "@/src/sb/components/icon/Lite"
import Search from "@/src/sb/components/icon/Search"
import classNames from "classnames"
import React, { useEffect, useState } from "react"

type QueryToolbarProps = {
  initialAiMode?: boolean
  onAiModeChange?: (ai: boolean) => void
  onSubmit?: (ai: boolean) => void
  onOpenSearch?: () => void
  onNavigateToAi?: () => void
  submitAriaLabel?: string
  className?: string
  disabled?: boolean
}

const QueryToolbar: React.FC<QueryToolbarProps> = ({
  initialAiMode = true,
  onAiModeChange,
  onSubmit,
  onOpenSearch,
  onNavigateToAi,
  submitAriaLabel = "submit follow up",
  className,
  disabled
}) => {
  const [aiMode, setAiMode] = useState<boolean>(initialAiMode)

  const setAiModeValue = (next: boolean) => {
    setAiMode(next)
    onAiModeChange?.(next)
  }

  useEffect(() => {
    setAiMode(initialAiMode)
  }, [initialAiMode])

  const handleSubmit = () => {
    onSubmit?.(aiMode)
  }

  const handleSearchClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    e.preventDefault()
    setAiModeValue(false)
    onOpenSearch?.()
  }

  const handleAiClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    e.preventDefault()
    if (!aiMode) {
      setAiModeValue(true)
      onNavigateToAi?.()
    }
  }

  const handleContainerClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation()
  }

  return (
    <div className={classNames("flex items-center justify-between", className)}>
      <div
        className=" rounded-lg bg-[#0B0C0D] p-1 flex items-center shrink-0 gap-0.5"
        onClick={handleContainerClick}
      >
        <button
          type="button"
          onClick={handleSearchClick}
          className={classNames(
            "w-9 h-9 flex items-center justify-center rounded-md transition-colors",
            !aiMode ? "bg-[#1F2937]" : "bg-[#0B0C0D]"
          )}
          aria-label="open search"
          aria-pressed={!aiMode}
        >
          <Search color={!aiMode ? "#FFFFFF" : "#9CA3AF"} size={12} />
        </button>

        <button
          type="button"
          onClick={handleAiClick}
          className={classNames(
            "inline-flex items-center gap-1 px-3 py-2 rounded-md text-xs transition-colors",
            aiMode ? "bg-[#1F2937] text-white" : "bg-[#0B0C0D] text-[#9CA3AF]"
          )}
          aria-pressed={aiMode}
        >
          <div className=" flex items-center gap-2.5 text-[#85BEFF]">
            <Lite size={14} />{" "}
            <span className="hidden sm:inline text-white">AI mode</span>
          </div>
        </button>
      </div>

      <button
        type="button"
        onClick={handleSubmit}
        disabled={disabled}
        className="w-9 h-9 rounded-md bg-stears_white text-stears_black disabled:bg-[#2F3742] disabled:text-white disabled:text-opacity-60 flex items-center justify-center shrink-0"
        aria-label={submitAriaLabel}
      >
        <ArrowRight size={20} />
      </button>
    </div>
  )
}

export default QueryToolbar
